import React from "react";
import { default as WSwipeableDrawer } from "@mui/material/SwipeableDrawer";

function SwipeableDrawer(props) {
  return <WSwipeableDrawer {...props} />;
}

export default SwipeableDrawer;
